<template>
  <gs-modal
    :value="open"
    size="xl"
    title="Share &amp; embed"
    class="gs-share-modal"
    @input="$emit('close')"
    @close="$emit('close')"
  >
    <div class="gs-share-modal__body">
      <publish-video
        :video-id="embed.video_id"
        :is-published="embed.is_published"
        :publishes-left="publishesLeft"
        @isLoading="$emit('isLoading', $event)"
        @updatePublishLimit="$emit('updatePublishLimit', $event)"
      />

      <template v-if="embed.is_published">
        <gs-card class="gs-share-modal__row">
          <copy-row
            label="Public URL"
            :value="embed.hosted_page_link"
            :primary="true"
            :openable="true"
            @open="openPublicUrl()"
            @copied="$emit('copied', 'url')"
            @copy-failed="$emit('copy-failed', 'url')"
          />

          <div class="gs-share-modal__toggles">
            <label class="gs-share-modal__toggle">
              <span>{{ $t('frontend_video_autoplay') }}</span>
              <gd-toggle
                v-model="embed.hosted_page_settings.autoplay"
                @change="$emit('updateHostedPageSettings')"
              />
            </label>
            <label
              v-if="embed.video_source_type == 1"
              class="gs-share-modal__toggle"
              v-tooltip.right="{
                content: !embed.download_available ? $t('frontend_video_download_unavailable') : '',
                classes: 'groovevideo-videos-tooltip',
                delay: { show: 200, hide: 200 },
              }"
            >
              <span>{{ $t('frontend_video_allow_download') }}</span>
              <gd-toggle
                v-model="embed.hosted_page_settings.allow_download"
                @change="$emit('checkDownloadable')"
              />
            </label>
          </div>
          <p class="gs-share-modal__note">
            *{{ $t('frontend_groovevideo_autoplay_will_start_muted_notification') + $t('frontend_groovevideo_autoplay_loop_in_background') }}
          </p>
        </gs-card>

        <gs-card class="gs-share-modal__row">
          <copy-row
            :label="$t('frontend_video_embed_code')"
            :value="embed.video_embed"
            :multiline="true"
            @copied="$emit('copied', 'embed')"
            @copy-failed="$emit('copy-failed', 'embed')"
          />
        </gs-card>

        <gs-card class="gs-share-modal__row">
          <copy-row
            v-if="embed.show_source_url"
            :label="$t('frontend_video_source_file_url')"
            :value="embed.source_file_url"
            @copied="$emit('copied', 'source')"
            @copy-failed="$emit('copy-failed', 'source')"
          />
          <template v-else>
            <h3 class="gs-share-modal__row-title">{{ $t('frontend_video_source_file_url') }}</h3>
            <p class="gs-share-modal__note">
              {{ $t('frontend_groovevideo_links_source_url_unavailable') }}
            </p>
          </template>
        </gs-card>
      </template>

      <p v-else class="gs-share-modal__hint">
        <gs-icon name="link" size="14" />
        <span>{{ $t('frontend_groovevideo_links_publish_video_to_activate') }}</span>
      </p>
    </div>
  </gs-modal>
</template>

<script>
import PublishVideo from '@/components/PublishVideo';
import CopyRow from '@/components/library/CopyRow.vue';

export default {
  name: 'ShareVideoModal',
  components: { PublishVideo, CopyRow },
  props: {
    embed: {
      type: Object,
      required: true,
    },
    publishesLeft: {
      type: Number,
      default: 0,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openPublicUrl() {
      window.open(this.embed.hosted_page_link, '_blank');
    },
  },
};
</script>

<style scoped>
.gs-share-modal__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px 28px 32px;
}

.gs-share-modal__row {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 20px;
}

.gs-share-modal__row-title {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 15px;
  font-weight: 650;
}

.gs-share-modal__toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.gs-share-modal__toggle {
  display: flex;
  gap: 8px;
  align-items: center;
  color: var(--gs-foreground);
  font-size: 13px;
  font-weight: 600;
}

.gs-share-modal__note {
  margin: 0;
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 600;
}

.gs-share-modal__hint {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 0;
  padding: 14px 16px;
  color: var(--gs-muted-foreground);
  background: var(--gs-surface-subtle);
  border-radius: var(--gs-radius-md);
  font-size: 13px;
}
</style>
